import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class WelcomeViewModel {
    ShowAlert:              (pTitle: string, pMessage: string) => void;
    BackToSignIn:           ()                                 => void;
    GoToHousekeeping:       ()                                 => void;
    NewLoading:             (pMessage: string)                 => dmLoading;

    mlText:                 MLText;
    app:                    mlBroker;
    ml:                     mlBroker;
    Hotel:                  dmHotel;
    Warnings:               RQService.Ota.CheckHotelConfigRow;
    LangID:                 number;

    Published:              boolean;
    PublishRequestPending:  boolean;
    NoPublishRequest:       boolean;

    constructor(
         pMLText:           MLText
        ,pHotel:            dmHotel
        ,pBackToSignIn:     ()                                 => void
        ,pGoToHousekeeping: ()                                 => void
        ,pShowAlert:        (pTitle: string, pMessage: string) => void
        ,pNewLoading:       (pMessage: string)                 => dmLoading
    ) {
        this.mlText                = pMLText;
        this.LangID                = this.mlText.GetLangID();
        this.app                   = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                    = this.mlText.GetBroker(
            'HotelAreaWelcome'
        );

        this.Hotel                 = pHotel;
        this.BackToSignIn          = pBackToSignIn;
        this.GoToHousekeeping      = pGoToHousekeeping;
        this.ShowAlert             = pShowAlert;
        this.NewLoading            = pNewLoading;

        this.NoPublishRequest      = true;
        this.PublishRequestPending = false;
        this.Published             = false;

        if (this.Hotel.HotelInfo.OtaPublishRequest == 1) {
            this.NoPublishRequest      = false;
            this.PublishRequestPending = true;
            this.Published             = false;
        }

        if (this.Hotel.HotelInfo.OtaPublish == 1) {
            this.NoPublishRequest      = false;
            this.PublishRequestPending = false;
            this.Published             = true;
        }

        this.Warnings         = RQService.Ota.PopulateCheckHotelConfigRow({});

        let warningParams     = RQParam.OtaCheckHotelConfigParams();

        warningParams.HotelID = this.Hotel.HotelID;

        RQService.Ota.CheckHotelConfig(warningParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            let warning = response.RQueryResult;

            this.Warnings = RQService.Ota.PopulateCheckHotelConfigRow(
                warning[0]
            );
        });
    }

    public MakePublishRequest(): void {
        let publishParams = RQParam.OtaMakeOTAPublishRequestParams();

        publishParams.HotelID = this.Hotel.HotelID;

        RQService.Ota.MakeOTAPublishRequest(publishParams).then(result => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            this.Hotel.HotelInfo.OtaPublishRequest = 1;

            this.NoPublishRequest      = false;
            this.PublishRequestPending = true;
            this.Published             = false;
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/welcome/xv-welcome.ts